import { multicallAddresses } from '@pancakeswap/multicall'

export default {
  masterChef: {
    97: '0xB4A466911556e39210a6bB2FaECBB59E4eB7E43d',
    56: '0xa5f8C5Dbd5F286960b9d90548680aE5ebFf07652',
    5: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    10: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    137: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    250: '',
  },
  masterChefV1: {
    97: '0x1d32c2945C8FDCBc7156c553B7cEa4325a17f4f9',
    56: '0x73feaa1eE314F8c655E354234017bE2193C9E24E',
    10: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    137: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    250: '',
  },
  sousChef: {
    97: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    56: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
    10: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    137: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    250: '',
  },
  lotteryV2: {
    97: '0x5790c3534F30437641541a0FA04C992799602998',
    56: '0x5aF6D33DE2ccEC94efb1bDF8f92Bd58085432d2c',
    10: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    137: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    250: '',
  },
  multiCall: multicallAddresses,
  pancakeProfile: {
    56: '0xDf4dBf6536201370F95e06A0F8a7a70fE40E388a',
    97: '0x4B683C7E13B6d5D7fd1FeA9530F451954c1A7c8A',
    10: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    137: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    250: '',
  },
  pancakeBunnies: {
    56: '0xDf7952B35f24aCF7fC0487D01c8d5690a60DBa07',
    97: '0x60935F36e4631F73f0f407e68642144e07aC7f5E',
    10: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    137: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    250: '',
  },
  bunnyFactory: {
    56: '0xfa249Caa1D16f75fa159F7DFBAc0cC5EaB48CeFf',
    97: '0x707CBF373175fdB601D34eeBF2Cf665d08f01148',
    10: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    137: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    250: '',
  },
  claimRefund: {
    56: '0xE7e53A7e9E3Cf6b840f167eF69519175c497e149',
    97: '',
    10: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    137: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    250: '',
  },
  pointCenterIfo: {
    56: '0x3C6919b132462C1FEc572c6300E83191f4F0012a',
    97: '0xd2Ac1B1728Bb1C11ae02AB6e75B76Ae41A2997e3',
    10: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    137: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    250: '',
  },
  bunnySpecial: {
    56: '0xFee8A195570a18461146F401d6033f5ab3380849',
    97: '0x7b7b1583De1DeB32Ce6605F6deEbF24A0671c17C',
    10: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    137: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    250: '',
  },
  tradingCompetitionEaster: {
    56: '0xd718baa0B1F4f70dcC8458154042120FFE0DEFFA',
    97: '0xC787F45B833721ED3aC46E99b703B3E1E01abb97',
    10: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    137: '0x8CB958bBdb45597cc918147469eb650A9397aBDA',
    250: '',
  },
  tradingCompetitionFanToken: {
    56: '0xA8FECf847e28aa1Df39E995a45b7FCfb91b676d4',
    97: '',
    10: '',
    137: '',
    250: '',
  },
  tradingCompetitionMobox: {
    56: '0x1C5161CdB145dE35a8961F82b065fd1F75C3BaDf',
    97: '',
    10: '',
    137: '',
    250: '',
  },
  tradingCompetitionMoD: {
    56: '0xbDd9a61c67ee16c10f5E37b1D0c907a9EC959f33',
    97: '',
    10: '',
    137: '',
    250: '',
  },
  easterNft: {
    56: '0x23c41D28A239dDCAABd1bb1deF8d057189510066',
    97: '0x24ec6962dbe874F6B67B5C50857565667fA0854F',
    10: '',
    137: '',
    250: '',
  },
  cakeVault: {
    56: '0x45c54210128a065de780C4B0Df3d16664f7f859e',
    97: '0x683433ba14e8F26774D43D3E90DA6Dd7a22044Fe',
    10: '',
    137: '',
    250: '',
  },
  cakeFlexibleSideVault: {
    56: '0x615e896A8C2CA8470A2e9dc2E9552998f8658Ea0',
    97: '',
    10: '',
    137: '',
    250: '',
  },
  predictionsBNB: {
    56: '0x18B2A687610328590Bc8F2e5fEdDe3b582A49cdA',
    97: '',
    137: '',
    10: '0x1b43CCf9aD2f57888094f0c05932f43D9D3e9fFc', // Prediction ETH
    250: '0xeA2Bd25D2Dd499Ee9d90289f7dF48C04AB1a3d92',
  },
  predictionsCAKE: {
    56: '0x0E3A8078EDD2021dadcdE733C6b4a86E51EE8f07',
    97: '',
    137: '0x57d57C56c77F32b4f9898fF45b8Ee10b5AaF7242',
    10: '0x1b43CCf9aD2f57888094f0c05932f43D9D3e9fFc', // Prediction ETH
    250: '0xeA2Bd25D2Dd499Ee9d90289f7dF48C04AB1a3d92',
  },
  chainlinkOracleBNB: {
    56: '0xD276fCF34D54A926773c399eBAa772C12ec394aC',
    97: '',
    137: '0xAB594600376Ec9fD91F8e885dADF0CE036862dE0',
    10: '0x13e3ee699d1909e989722e753853ae30b17e08c5', // Price ETH
    250: '0xf4766552D15AE4d256Ad41B6cf2933482B0680dc', // Price FTM
  },
  chainlinkOracleCAKE: {
    56: '0xB6064eD41d4f67e353768aA239cA86f4F73665a1',
    97: '',
    137: '0xAB594600376Ec9fD91F8e885dADF0CE036862dE0', // price OP
    10: '0x13e3ee699d1909e989722e753853ae30b17e08c5', // Price ETH
    250: '0xf4766552D15AE4d256Ad41B6cf2933482B0680dc', // Price FTM
  },
  predictionsV1: {
    56: '0x516ffd7d1e0ca40b1879935b2de87cb20fc1124b',
    97: '',
    137: '',
    10: '',
    250: '',
  },
  bunnySpecialCakeVault: {
    56: '0x5B4a770Abe7Eafb2601CA4dF9d73EA99363E60a4',
    97: '',
    137: '',
    10: '',
    250: '',
  },
  bunnySpecialPrediction: {
    56: '0x342c99e9aC24157657095eC69CB04b73257e7A9C',
    97: '',
    137: '',
    10: '',
    250: '',
  },
  bunnySpecialLottery: {
    56: '0x24ED31d31C5868e5a96aA77fdcB890f3511fa0b2',
    97: '0x382cB497110F398F0f152cae82821476AE51c9cF',
    137: '',
    10: '',
    250: '',
  },
  bunnySpecialXmas: {
    56: '0x59EdDF3c21509dA3b0aCCd7c5ccc596d930f4783',
    97: '',
    137: '',
    10: '',
    250: '',
  },
  farmAuction: {
    56: '0xb92Ab7c1edcb273AbA24b0656cEb3681654805D2',
    97: '0x3F9602593b4f7C67ab045DB51BbDEa94E40fA9Fe',
    137: '',
    10: '',
    250: '',
  },
  AnniversaryAchievement: {
    56: '0xF839286bD9D14b358496829F3BaB3145C16ad3C1',
    97: '0x981aE96378e770DE44F89cD9175E708f9EDB70a9',
    137: '',
    10: '',
    250: '',
  },
  nftMarket: {
    56: '0x17539cCa21C7933Df5c980172d22659B8C345C5A',
    97: '0x7f9f37ddcaa33893f9beb3d8748c8d6bfbde6ab2',
    137: '',
    10: '',
    250: '',
  },
  nftSale: {
    56: '0x29fE7148636b7Ae0b1E53777b28dfbaA9327af8E',
    97: '0xe486De509c5381cbdBF3e71F57D7F1f7570f5c46',
    137: '',
    10: '',
    250: '',
  },
  pancakeSquad: {
    56: '0x0a8901b0E25DEb55A87524f0cC164E9644020EBA',
    97: '0xfC0c3F11fDA72Cb9A56F28Ec8D44C0ae4B3ABF86',
    137: '',
    10: '',
    250: '',
  },
  potteryDraw: {
    56: '0x01871991587d5671f3A2d4E2BcDC22F4E026396e',
    97: '0xDB9D365b50E62fce747A90515D2bd1254A16EbB9',
    137: '',
    10: '',
    250: '',
  },
  // TODO: multi
  zap: {
    56: '0xD4c4a7C55c9f7B3c48bafb6E8643Ba79F42418dF',
    97: '0xD85835207054F25620109bdc745EC1D1f84F04e1',
    137: '',
    10: '',
    250: '',
  },
  iCake: {
    56: '0x3C458828D1622F5f4d526eb0d24Da8C4Eb8F07b1',
    97: '',
    137: '',
    10: '',
    250: '',
  },
  bCakeFarmBooster: {
    56: '0xE4FAa3Ef5A9708C894435B0F39c2B440936A3A52',
    97: '',
    137: '',
    10: '',
    250: '',
  },
  bCakeFarmBoosterProxyFactory: {
    56: '0x2C36221bF724c60E9FEE3dd44e2da8017a8EF3BA',
    97: '',
    137: '',
    10: '',
    250: '',
  },
}
